<template>
  <div>
    <div ref="chart" :id="boxId" style="width: 45vw; height: 400px;"></div>
    <div :id="tipId" class="custom-tooltip">
      <el-input v-model="searchInput" placeholder="请输入..." size="mini" @change="filterChange"></el-input>

      <div style="margin-top: 5px"><b>{{ currentTime }}</b></div>

      <el-table :cell-style="{padding:0}"
                :data="filterTip" class="no-border" style="width: 260px" :show-header="false" max-height="300px">
        <el-table-column prop="color" label="颜色" width="20">
          <template v-slot="{row}">
            <div :style="{backgroundColor:row.color}" style="width: 10px;height: 10px;border-radius: 5px"></div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="设备" width="150"></el-table-column>
        <el-table-column prop="value" label="值" width="90"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "DashChart",
  props: {
    boxId: [String],
    tipId: [String],
    title: [String],
    series: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataSets: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      devStats: [],
      filterTip: [],
      searchInput: "",
      currentTime: "",
      chart: null,
      option: null,
    }
  },
  mounted() {
    this.initChart();
    this.getData();
  },
  watch:{
    series: {
      handler(newVal, oldVal) {
        this.option.series=newVal;
        this.chart.setOption(this.option,true,true)
      },
      deep: true
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize);
  },
  methods: {
    initChart() {
      this.option = {
        renderer: 'svg',
        animation: true, // 关闭动画，避免二次渲染
        tooltip: {
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        xAxis: {
          type: 'time',
          boundaryGap: false
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%']
        },
        legend: {
          type: "scroll", // 使用滚动类型的图例
          itemHeight:18,
          bottom: 0, // 图例显示在底部
        },
        toolbox: {
          show:true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            restore: {},
            saveAsImage: {}
          }
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          }
        ],
        series: this.series
      };
      this.chart = echarts.init(document.getElementById(this.boxId),null, { renderer: 'svg' });
      // var chart = echarts.init(containerDom, null, { renderer: 'svg' });
      this.chart.setOption(this.option);
    },
    filterChange() {
      this.filterTip = []
      this.devStats.forEach(e => {
        if (e.name.includes(this.searchInput)) {
          this.filterTip.push(e)
        }
      })
    },
    chartResize(){
      this.chart.resize()
    },
    getData() {
      let self = this;
      let isTooltipFixed = false; // 布尔变量来跟踪悬浮框是否已固定

      window.addEventListener('resize', this.chartResize);
      // window.addEventListener('resize', () => {
      //   self.chart.resize()
      // });


      let tooltip = document.getElementById(self.tipId);
      self.chart.getZr().on('mousemove', function (params) {
        if (isTooltipFixed) {
          // 如果悬浮框是固定的，则不更新位置
          return;
        }

        let pointInPixel = [params.offsetX, params.offsetY];

        if (self.chart.containPixel('grid', pointInPixel)) {
          let pointInGrid = self.chart.convertFromPixel('grid', pointInPixel);

          if (self.chart.containPixel('grid', pointInPixel)) {
            let xValue = pointInGrid[0];
            let date = new Date(xValue);

            // 格式化日期和时间
            let year = date.getFullYear();
            let month = (date.getMonth() + 1).toString().padStart(2, '0');
            let day = date.getDate().toString().padStart(2, '0');
            let hours = date.getHours().toString().padStart(2, '0');
            let minutes = date.getMinutes().toString().padStart(2, '0');
            let seconds = date.getSeconds().toString().padStart(2, '0');
            let dateStr = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            self.currentTime = dateStr;
            // 遍历所有数据集
            let arr = [];
            let series = self.chart.getOption().series; // 获取系列数组
            let globalColors = self.chart.getOption().color; // 获取全局颜色配置
            let legend = self.chart.getOption().legend; // 获取图例选中状态

            // 如果 legend 不存在或者里面没有 selected 属性，直接返回
            if (!legend || !legend[0].selected) {
              console.log("图例状态不可用");
              return;
            }

            let legendSelected = legend[0].selected;



            for (let j = 0; j < self.dataSets.length; j++) {
              const dataset = self.dataSets[j];
              const data = dataset.data;

              // 检查图例是否可见
              if (legendSelected[dataset.name] === false) {
                // 如果在选中状态中显式设为 false，则不显示
                continue;
              }

              let value = '';
              let seriesColor = globalColors[j % globalColors.length] || '#000000'; // 默认使用全局颜色

              // 查找当前数据集对应的系列并获取它的颜色
              for (let s of series) {
                if (s.name === dataset.name) {
                  if (s.itemStyle && s.itemStyle.color) {
                    seriesColor = s.itemStyle.color;
                  } else if (s.lineStyle && s.lineStyle.color) {
                    seriesColor = s.lineStyle.color;
                  } else if (s.color) {
                    seriesColor = s.color;
                  }
                  break;
                }
              }

              if (data && data.length > 0) {
                // 查找当前时间点的值或者前一个有值的点
                for (let i = 0; i < data.length; i++) {
                  if (data[i][0] >= xValue) {
                    if (data[i][0] == xValue) {
                      value = data[i][1].toFixed(2); // 当前时间点有值，取当前值
                    } else if (i > 0 && xValue - dataset.len <= data[i - 1][0]) {
                      value = data[i - 1][1].toFixed(2); // 当前时间点无值，取前一个有值的点
                    }
                    break;
                  } else if (i == data.length - 1 && xValue - dataset.len <= data[i][0]) {
                    value = data[i][1].toFixed(2); // 如果时间点之后没有值，取最后一个点的值
                  }
                }

                if (value != "") {
                  let obj = {
                    name: dataset.name,
                    value: value,
                    color: seriesColor // 添加颜色到对象
                  };
                  arr.push(obj);
                }
              }
              // 从大到小排序
              arr.sort((a, b) => b.value - a.value);
              self.devStats = arr;
              self.filterTip = arr;
            }


            // 使用 getBoundingClientRect() 方法来获取 chart 相对于文档的位置，然后用这个位置来修正 tooltip 的位置
            let chartRect = self.chart.getDom().getBoundingClientRect();
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

            // tooltip.style.left = chartRect.left + scrollLeft + params.event.offsetX + 30 + 'px';
            // tooltip.style.top = chartRect.top + scrollTop + params.event.offsetY + 'px';


            let tooltipWidth = tooltip.offsetWidth;
            let windowWidth = window.innerWidth;
            let tooltipLeft = chartRect.left + scrollLeft + params.event.offsetX + 30;

            if (tooltipLeft + tooltipWidth > windowWidth) {
              tooltipLeft = chartRect.left + scrollLeft + params.event.offsetX - tooltipWidth - 30;
            }

            tooltip.style.left = tooltipLeft + 'px';
            tooltip.style.top = chartRect.top + scrollTop + params.event.offsetY + 'px';
            tooltip.style.display = 'block';
          }
        } else {
          tooltip.style.display = 'none';
        }
      });

      self.chart.getZr().on('mouseout', function () {
        if (!isTooltipFixed) {
          tooltip.style.display = 'none';
        }
      });

      // 添加键盘事件监听
      document.addEventListener('keydown', function (event) {
        if (event.ctrlKey && event.key.toLowerCase() === 'q') {
          isTooltipFixed = !isTooltipFixed; // 切换布尔变量的值
        }
      });

      // 添加鼠标滚轮事件监听
      tooltip.addEventListener('wheel', function (event) {
        if (isTooltipFixed) {
          event.stopPropagation(); // 防止滚动事件冒泡到浏览器
        }
      });
    }
  }
}
</script>


<style scoped>

/*去掉表格最下面的线*/
.el-table::before {
  height: 0;
}

/*去掉表格的所有框线*/
.no-border /deep/ .el-table__body td,
.no-border /deep/ .el-table__header th {
  border-color: transparent !important;
}


.custom-tooltip {
  position: absolute;
  /*max-height: 300px;*/
  /*max-width: 600px;*/
  background-color: white;
  color: #1d1c1c;
  padding: 10px;
  border: 1px solid #e7e5e5;
  border-radius: 5px;
  /*pointer-events: none;*/
  display: none;
  overflow-y: auto;
  z-index: 9999;
}
</style>
